import axios from "axios";
import {API} from "@/env";

export default {

    /**
     * WebSite internal Settings
     * @param,
     * @api {GET} api/web/getInternalSettings
     */
    get_competitions(param) {

        const options = {
            method: 'GET',
            url: API + 'api/web/getCompetitions',
            headers: {'content-type': 'application/json'},
            params:param,
        };

        return new Promise( (resolve,reject) => {
            axios(options).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.data);
            });
        });

    }

}
